<template>
  <div class="d-reviewers-search-number-results">
    <p v-if="totalCount">
      We found
      <strong>{{ totalCount }} {{ totalCount | duiPluralize('reviewer', 'reviewers') }}</strong>
      that {{ totalCount | duiPluralize('matches', 'match') }} your search
      <span class="emoji">🔦</span>
    </p>

    <p v-else>
      We can't find any reviewers that match your search
      <span class="emoji">🔦</span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    totalCount: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-reviewers-search-number-results {
  margin: 0 $_2em $_3em;
  text-align: center;

  p {
    margin: 0;
  }
}
</style>
